export default __webpack_public_path__ + "static/media/565.6ebd5c5a.png";